<div
  class="card"
  *appIsGranted="['PACKETS_LASTPOSITIONS', 'PACKETS_LASTPOSITIONS', 'READ']"
>
  <div class="card-body column">
    <div class="row">
      <h6 class="card">Pesquisa de Última Posição</h6>
      <div class="col-md-7">
        <label for="serial" class="col-md-2 col-form-label">Seriais</label>
        <input class="w-75" placeholder="205502151; ..." [(ngModel)]="serial" />
      </div>
      <div class="col-md-2">
        <div class="form-check mb-2">
          <input
            class="form-check-input"
            type="checkbox"
            id="formCheck1"
            [(ngModel)]="showMap"
          />
          <label class="form-check-label" for="formCheck1">
            Mostrar Mapa
          </label>
        </div>
        <div class="d-inline">
          <input
            class="form-check-input ms-2"
            type="radio"
            name="formRadios"
            id="formRadios1"
            value="0"
            [(ngModel)]="prettyEvent"
            checked
          />
          <label class="form-check-label" for="formRadios1"> 0 </label>
          <input
            class="form-check-input ms-2"
            type="radio"
            name="formRadios"
            id="formRadios2"
            value="1"
            [(ngModel)]="prettyEvent"
          />
          <label class="form-check-label" for="formRadios2"> 1 </label>
          <input
            class="form-check-input ms-2"
            type="radio"
            name="formRadios"
            id="formRadios3"
            value="2"
            [(ngModel)]="prettyEvent"
          />
          <label class="form-check-label" for="formRadios2"> 2 </label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="column">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            style="margin-right: 5px"
            (click)="searchLastPosition()"
          >
            Pesquisar
          </button>
        </div>

        <div class="col-md-2">
          <button
            class="button-row"
            mat-button
            matTooltip="Exportar para excel"
            *ngIf="positionEvent.length > 0"
            (click)="exportExcel()"
          >
            <img
              class="logo-image"
              src="../../../assets/images/icon-excel.png"
              style="width: 25px; height: 25px"
            />
          </button>
        </div>
      </div>
      <div class="dropdown mt-1" ngbDropdown>
        <button
          class="btn btn-sm btn-primary dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          ngbDropdownToggle
        >
          Ações <i class="mdi mdi-chevron-down"></i>
        </button>
        <div
          class="dropdown-menu"
          aria-labelledby="dropdownMenuButton"
          ngbDropdownMenu
        >
          <a class="btn dropdown-item" (click)="exportExcel()"
            >Exportar Excel</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
<div class="card align-items-center" *ngIf="circularProgressiveWait">
  <div card="card-body">
    <div class="spinner-border text-primary m-1" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>
<div class="card">
  <!-- Nav tabs -->
  <ul
    ngbNav
    #customNav="ngbNav"
    [activeId]="1"
    class="nav nav-tabs nav-tabs-custom"
  >
    <li [ngbNavItem]="1">
      <a ngbNavLink>
        <span class="d-block d-sm-none"><i class="fas fa-battery"></i></span>
        <span class="d-none d-sm-block">Última Posicao</span>
      </a>
      <ng-template ngbNavContent>
        <ng-template [ngTemplateOutlet]="TablastPosition"></ng-template>
      </ng-template>
    </li>
    <li
      [ngbNavItem]="2"
      (click)="selectTabAnalytics()"
      [disabled]="positionEventJson.length == 0"
    >
      <a ngbNavLink>
        <span class="d-block d-sm-none"><i class="fas fa-signal"></i></span>
        <span class="d-none d-sm-block">Análise</span>
      </a>
      <ng-template ngbNavContent>
        <ng-template [ngTemplateOutlet]="TabCountEvents"></ng-template>
      </ng-template>
    </li>
    <ng-container *ngIf="serialsWithoutResult != ''">
      <li [ngbNavItem]="3" [disabled]="serialsWithoutResult == ''">
        <a ngbNavLink>
          <span class="d-block d-sm-none"
            ><i class="fas fa-exclamation-circle"></i
          ></span>
          <span class="d-none d-sm-block">Sem resultados</span>
        </a>
        <ng-template ngbNavContent>
          <ng-template [ngTemplateOutlet]="TabWithoutResults"></ng-template>
        </ng-template></li
    ></ng-container>
  </ul>

  <!-- Tab panes -->
  <div class="tab-content p-3 text-muted">
    <div [ngbNavOutlet]="customNav"></div>
  </div>
</div>
<!-- end card body -->

<ng-template #TablastPosition>
  <div class="row mt-n3">
    <div class="w-100">
      <as-split direction="horizontal">
        <as-split-area [size]="showMap ? 60 : 100">
          <ng-container *ngIf="!circularProgressiveWait">
            <div [fluidHeight] style="min-height: 80vh">
              <table class="table table-fit table-bordered table-hover">
                <thead class="table-primary">
                  <tr>
                    <th class="col text-center" scope="col">#</th>
                    <th class="col text-center" scope="col">Serial</th>
                    <th class="col text-center" scope="col">
                      DataHoraEnvio<br />DataHoraRequisicao<br />DataHoraResposta
                    </th>
                    <th class="col text-center" scope="col">Evento</th>
                    <th class="col" scope="col">Pacote</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let position of positionEventJson; let i = index">
                    <td class="text-center" scope="row">
                      <button
                        class="btn btn-sm btn-purple btn-rounded me-2"
                        (click)="setCenterPositionOnMapAndOpenInfoBox(i)"
                      >
                        {{ i + 1 }}
                      </button>
                    </td>
                    <td class="text-center" scope="row">
                      {{ position.rastreador.numero_serie }}
                    </td>
                    <td class="text-center" scope="row">
                      {{ position.data_hora_evento }} <br />
                      {{ position.data_hora_recebimento }} <br />
                      {{ position.data_hora_armazenamento }}
                    </td>
                    <td class="text-center" scope="row">
                      <span style="color: red; font-weight: bold">
                        {{ position.tipo_evento }}
                      </span>
                    </td>
                    <td
                      class="overflow-auto"
                      style="word-break: break-all"
                      scope="row"
                    >
                      <div *ngIf="prettyEvent == '0'">
                        <p
                          [innerHTML]="
                            position
                              | jsonToStringPipe
                              | highlightSearch : textHighlight
                          "
                        ></p>
                      </div>
                      <div *ngIf="prettyEvent == '1'">
                        <ngx-json-viewer
                          [json]="position"
                          [expanded]="false"
                        ></ngx-json-viewer>
                      </div>
                      <div *ngIf="prettyEvent == '2'">
                        <ngx-json-viewer
                          [json]="position"
                          [depth]="3"
                        ></ngx-json-viewer>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
        </as-split-area>
        <as-split-area [size]="showMap ? 40 : 0">
          <div class="d-inline">
            <div id="map" [minHeight]="200" [fluidHeight]></div>
            <div class="card align-items-center" *ngIf="!maps">
              <div card="card-body mt-n3">
                <p>Carregando o mapa</p>
                <div class="spinner-border text-primary m-1" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div>
              <span class="badge rounded-pill badge-outline-dark ms-1">
                <img
                  src="../../../assets/images/positionArrow/arrow-ok.svg"
                  alt=""
                  class="rounded avatar-xs"
                />

                <label>GPS:True Online:True</label>
              </span>
              <span class="badge rounded-pill badge-outline-dark ms-1">
                <img
                  src="../../../assets/images/positionArrow/arrow-sem-gps.svg"
                  alt=""
                  class="rounded avatar-xs"
                />
                <label>GPS:False Online:True</label>
              </span>
              <span class="badge rounded-pill badge-outline-dark ms-1">
                <img
                  src="../../../assets/images/positionArrow/arrow-memoria.svg"
                  alt=""
                  class="rounded avatar-xs"
                />
                <label>GPS:True Online:False</label>
              </span>
              <span class="badge rounded-pill badge-outline-dark ms-1">
                <img
                  src="../../../assets/images/positionArrow/arrow-sem-gps-memoria.svg"
                  alt=""
                  class="rounded avatar-xs"
                />
                <label>GPS:False Online:False</label>
              </span>
              <span class="badge rounded-pill badge-outline-dark ms-1">
                <img
                  src="../../../assets/images/carrinho-p2p.png"
                  alt=""
                  class="rounded avatar-xs"
                />
                <label>Pacote P2P</label>
              </span>
              <span class="badge rounded-pill badge-outline-dark ms-1">
                <img
                  src="../../../assets/images/tower.png"
                  alt=""
                  class="rounded avatar-xs"
                />
                <label>Pacote LoRaWAN</label>
              </span>
            </div>
          </div>
        </as-split-area>
      </as-split>
    </div>
  </div>
</ng-template>

<!-- Tab Contagem de Eventos -->
<ng-template #TabCountEvents>
  <ng-select
    class="w-50 mb-3"
    id="fieldSelect"
    placeholder="Selecione um campo"
    [(ngModel)]="graphFieldSelect"
    (change)="countEventGraphBarMountAndTable(graphFieldSelect)"
  >
    <ng-option *ngFor="let field of headers" [value]="field">
      {{ field }}
    </ng-option>
  </ng-select>
  <div class="w-50" style="display: block">
    <canvas
      [ngClass]="{ 'd-none': barChartData.length < 1 }"
      baseChart
      [datasets]="barChartData"
      [labels]="barChartLabels"
      [options]="barChartOptions"
      [plugins]="barChartPlugins"
      [legend]="barChartLegend"
      chartType="barChartType"
    >
    </canvas>
  </div>
  <div class="h-75">
    <pre [innerHTML]="tableCountEventHTMLString"></pre>
  </div>
</ng-template>

<!-- Tab Sem resultados -->
<ng-template #TabWithoutResults>
  <div class="card">
    <span>{{ serialsWithoutResult }}</span>
  </div>
</ng-template>
